import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgetComponent } from './forget/forget.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ResetComponent } from './reset/reset.component';



@NgModule({
  declarations: [ForgetComponent, ResetComponent],
  imports: [
    CommonModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatDialogModule,
      MatInputModule,
      MatFormFieldModule,
      FormsModule
  ]
})
export class PasswordModule { }
